/**
 * Frontend Script
 */
jQuery(document).ready(function($) {
    $('.wp-block-custom-blocks-bonusrechner').each(function () {
        const rangecontrol = $(this).find('input[type="range"]');
        const output = $(this).find('.bonus');
        const bonus = rangecontrol.data('bonus');
        const list = $(this).find('.datalist');

        list.find('span').on('click', function(){
            rangecontrol.val($(this).text());
            output.text($(this).text() * bonus + "€");
        });

        rangecontrol.on('input change', function () {
            output.text($(this).val() * bonus + "€");
        })
    })

})



// WEBPACK FOOTER //
// ./src/blocks/bonusrechner/js/script.js